import { Spacing, Title } from '@vkontakte/vkui';
import React, { type FC, memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';
import { generateImageAnimationEnd } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.actions';
import {
    getAiGenerationImageLoaderTextVariant,
    getAiGenerationImagePercentage,
} from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.selectors';
import LottieFetch from 'reactApp/ui/Lottie/LottieFetch';

import styles from './AiPhotoGenerationLoaderFinish.css';

export const AiPhotoGenerationLoaderFinish: FC = memo(function FullScreenAiPhotoGenerationLoaderFinish() {
    const text = useSelector(getAiGenerationImageLoaderTextVariant);
    const startPercentageValue = useSelector(getAiGenerationImagePercentage);
    const [currentPercentage, setCurrentPercentage] = useState(startPercentageValue || 0);
    const dispatch = useDispatch();

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentPercentage((prev) => Math.min(prev + 1, 100));
        }, 50);

        return () => clearInterval(intervalId);
    }, []);

    useEffect(() => {
        if (currentPercentage >= 100) {
            dispatch(generateImageAnimationEnd());
        }
    }, [currentPercentage, dispatch]);

    return (
        <>
            <LottieFetch src={`${cdnPackagesUrl}/static/cloud/ai/photo-generation/loader/loader.json`} className={styles.lottie} />
            <div className={styles.container}>
                <Title className={styles.percentage}>{currentPercentage}%</Title>
                <Spacing size={24} />
                <Title className={styles.title}>{text}</Title>
                <Spacing size={8} />
                <span className={styles.text}>Изображение генерируется</span>
                <Spacing size={96} />
                <Spacing size={48} />
            </div>
        </>
    );
});

AiPhotoGenerationLoaderFinish.displayName = 'AiPhotoGenerationLoaderFinish';
